import React, { FC } from 'react'

import { gpsStatusIcons } from 'shared/utils/gpsStatusIcons'

import { GpsBadgeProps } from './GpsBadge.props'

import './GpsBadge.scss'
import { cn } from 'shared/utils'

const GpsBadge: FC<GpsBadgeProps> = ({ gpsStatus, coloredBackground, className }) => {
  const gpsIcon = gpsStatusIcons[gpsStatus]

  if (!gpsIcon) return null

  const color = coloredBackground ? 'white' : gpsIcon.color
  const backgroundColor = coloredBackground ? gpsIcon.color : 'transparent'
  const borderColor = coloredBackground ? gpsIcon.color : 'transparent'

  return (
    <div className={cn('gps-badge', className)} style={{ color, backgroundColor, borderColor }}>
      {gpsIcon.description}
    </div>
  )
}

export default GpsBadge
